import type {
  ValueClassCompositionPreview,
  ValueCompositionRow,
} from '../../types/modelScoring';

const emptyPreview = (): ValueClassCompositionPreview => ({
  high_pct: 0,
  medium_pct: 0,
  low_pct: 0,
  high_count: 0,
  total_count: 0,
  est_ecpm_lift_pct: null,
});

/**
 * Maps API `valueCompositions` to UI preview for the audience-size slider index.
 * `lalRelativeDiff` is a fractional relative difference (BQ); shown as integer %.
 */
export function buildValueClassCompositionPreview(
  valueCompositions: ValueCompositionRow[] | undefined | null,
  lalModelPrecision: number
): ValueClassCompositionPreview {
  const rows = valueCompositions ?? [];
  const row = rows.find(
    (r) => Number(r.percentileBreakpoint) === Number(lalModelPrecision)
  );
  if (!row) {
    return emptyPreview();
  }

  const h = row.highCount ?? 0;
  const m = row.medCount ?? 0;
  const l = row.lowCount ?? 0;
  const sum = h + m + l;
  const high_pct = sum > 0 ? h / sum : 0;
  const medium_pct = sum > 0 ? m / sum : 0;
  const low_pct = sum > 0 ? l / sum : 0;

  const highHem = row.highHemCount ?? 0;
  const hem = row.hemCount ?? 0;

  let est_ecpm_lift_pct: number | null = null;
  if (
    row.lalRelativeDiff != null &&
    Number.isFinite(Number(row.lalRelativeDiff))
  ) {
    est_ecpm_lift_pct = Math.round(Number(row.lalRelativeDiff) * 100);
  }

  return {
    high_pct,
    medium_pct,
    low_pct,
    high_count: highHem,
    total_count: hem,
    est_ecpm_lift_pct,
  };
}
